import React from 'react';

/*
 * Social auth buttons (Google working via Emergent Auth, Apple coming soon).
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 *
 * Mode prop: 'signin' | 'signup' changes the button copy.
 */
export default function SocialAuthButtons({ mode = 'signin' }) {
    const actionWord = mode === 'signup' ? 'Sign up' : 'Sign in';

    const handleGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + '/dashboard';
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="mt-6" data-testid="social-auth-buttons">
            {/* Divider */}
            <div className="relative my-5" aria-hidden="true">
                <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-zinc-200" />
                </div>
                <div className="relative flex justify-center">
                    <span className="bg-white px-3 text-[11px] font-bold text-zinc-500 uppercase tracking-wider">
                        or continue with
                    </span>
                </div>
            </div>

            {/* Buttons row */}
            <div className="grid grid-cols-2 gap-3">
                {/* Google */}
                <button
                    type="button"
                    onClick={handleGoogle}
                    className="flex items-center justify-center gap-2.5 bg-white text-zinc-950 font-bold text-sm py-3 px-4 rounded-lg border-2 border-zinc-950 shadow-[2px_2px_0_0_rgba(9,9,11,1)] hover:shadow-[1px_1px_0_0_rgba(9,9,11,1)] hover:translate-x-[1px] hover:translate-y-[1px] transition-all"
                    data-testid="google-auth-button"
                    aria-label={`${actionWord} with Google`}
                >
                    <GoogleLogo />
                    <span className="hidden sm:inline">{actionWord}</span>
                    <span>with Google</span>
                </button>

                {/* Apple (disabled — coming soon) */}
                <button
                    type="button"
                    disabled
                    title="Apple Sign-In coming soon"
                    className="flex items-center justify-center gap-2.5 bg-black text-white font-bold text-sm py-3 px-4 rounded-lg border-2 border-black shadow-[2px_2px_0_0_rgba(9,9,11,1)] opacity-60 cursor-not-allowed relative"
                    data-testid="apple-auth-button"
                    aria-label={`${actionWord} with Apple (coming soon)`}
                >
                    <AppleLogo />
                    <span className="hidden sm:inline">{actionWord}</span>
                    <span>with Apple</span>
                    <span className="absolute -top-2 -right-2 px-1.5 py-0.5 bg-[#7C3AED] text-white text-[9px] font-black rounded-full uppercase tracking-wide">
                        Soon
                    </span>
                </button>
            </div>
        </div>
    );
}

/* ----- Brand logos (inline SVG — no external fetch) ----- */

function GoogleLogo() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
            />
            <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
            />
            <path
                d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83z"
                fill="#FBBC05"
            />
            <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"
                fill="#EA4335"
            />
        </svg>
    );
}

function AppleLogo() {
    return (
        <svg width="16" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
        </svg>
    );
}
